import { Button } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../api/hooks/useColors";
import AddNotificationModal from "./AddNotificationModal";

const CreateManualInAppNotification = () => {
  const colors = useColors();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div>
      <Button
        variant="outlined"
        sx={{
          backgroundColor: colors.secondary_main,
          "&:hover": {
            backgroundColor: colors.secondary_dark,
          },
        }}
        color="primary"
        onClick={handleOpen}
      >
        Create Manual Inbox Notification
      </Button>
      <AddNotificationModal open={open} handleClose={handleClose} />
    </div>
  );
};

export default CreateManualInAppNotification;
